export default __webpack_public_path__ + "static/media/rec1.c599aa1f.svg";